import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export interface AuthenticationResponse {
  name?: string
  document?: string
}

export default (accessToken?: string) => {
  const pathname = 'authentication'
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST as string
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request<AuthenticationResponse>({
    headers,
    pathname,
    method,
    host,
  })

  return response
}
